declare const __MOCKUP_API_BASE_URL__: string | undefined;
declare const __MOCKUP_APP_URL__: string | undefined;

export const API_BASE_URL = (__MOCKUP_API_BASE_URL__ || '').trim().replace(/\/$/, '');
export const INDEX_URL = API_BASE_URL ? `${API_BASE_URL}/mockups/index.json` : '';
export const MOTION_EXPORT_SESSIONS_URL = API_BASE_URL ? `${API_BASE_URL}/motion-export-sessions` : '';

/** Public URL of the web app. Used to build browser export links when the code
 *  runs inside a Figma plugin iframe where window.location.href is not reliable. */
export const APP_URL = (__MOCKUP_APP_URL__ || '').trim().replace(/\/$/, '');
